import { render, staticRenderFns } from "./RelogModal.vue?vue&type=template&id=645cafdc&scoped=true&"
import script from "./RelogModal.vue?vue&type=script&lang=js&"
export * from "./RelogModal.vue?vue&type=script&lang=js&"
import style0 from "./RelogModal.vue?vue&type=style&index=0&id=645cafdc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "645cafdc",
  null
  
)

export default component.exports